import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, withKeys as _withKeys } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "totalcalc" }
const _hoisted_5 = { class: "totalcalc" }
const _hoisted_6 = { class: "totalcalc" }
const _hoisted_7 = { class: "totalcalc" }
const _hoisted_8 = { class: "totalcalc" }
const _hoisted_9 = { class: "totalcalc" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_DateRangeInputField = _resolveComponent("DateRangeInputField")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_SelectField = _resolveComponent("SelectField")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_card, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, { "no-gutters": "" }, {
            default: _withCtx(() => [
              _cache[13] || (_cache[13] = _createElementVNode("span", { class: "mt-2" }, " Timesheet Report", -1)),
              _createVNode(_component_v_divider, {
                class: "mx-4",
                inset: "",
                vertical: ""
              }),
              _createVNode(_component_v_spacer)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_text, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                md: "3",
                sm: "4"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DateRangeInputField, {
                    modelValue: _ctx.selectedDateRange,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedDateRange) = $event)),
                    label: "Report Date Range",
                    "first-day-of-week": "1",
                    "hide-actions": "",
                    placeholder: "Select Report Date Range",
                    "prepend-icon": ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                md: "1",
                sm: "1",
                class: "mt-9"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_menu, {
                    "offset-y": "",
                    left: "",
                    attach: ""
                  }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn, _mergeProps({
                        small: "",
                        icon: "",
                        light: ""
                      }, props), {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            icon: "",
                            cir: ""
                          }, {
                            default: _withCtx(() => _cache[14] || (_cache[14] = [
                              _createTextVNode(" mdi-menu-down ")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1040)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_list, {
                        flat: "",
                        class: "pa-6"
                      }, {
                        default: _withCtx(() => [
                          _cache[15] || (_cache[15] = _createTextVNode(" Options ")),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dateRanges, (item) => {
                            return (_openBlock(), _createBlock(_component_v_list_item, {
                              key: item,
                              value: item,
                              title: item,
                              onClick: ($event: any) => (_ctx.selectedRange(item))
                            }, null, 8, ["value", "title", "onClick"]))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                md: "3",
                sm: "4"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_SelectField, {
                    class: "action-field",
                    items: _ctx.projectLeads,
                    "item-title": "text",
                    "item-value": "id",
                    modelValue: _ctx.selectedProjectLead,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedProjectLead) = $event)),
                    label: "Project Lead",
                    placeholder: "Project Lead",
                    dense: "",
                    outlined: ""
                  }, null, 8, ["items", "modelValue"])
                ]),
                _: 1
              }),
              (_ctx.selectedProjectLead)
                ? (_openBlock(), _createBlock(_component_v_col, {
                    key: 0,
                    cols: "12",
                    md: "3",
                    sm: "4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_SelectField, {
                        class: "action-field",
                        items: _ctx.teammembers,
                        "item-title": "text",
                        multiple: "",
                        "item-value": "id",
                        modelValue: _ctx.selectedTeammembers,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedTeammembers) = $event)),
                        label: "Teammembers",
                        plcaholder: "Teammembers",
                        dense: "",
                        outlined: ""
                      }, null, 8, ["items", "modelValue"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_v_col, {
                md: "2",
                sm: "4",
                cols: "12"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    class: "accent action-button mt-9",
                    color: "primary",
                    loading: _ctx.isLoading,
                    onClick: _ctx.createReport
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => _cache[16] || (_cache[16] = [
                          _createTextVNode("mdi-sync")
                        ])),
                        _: 1
                      }),
                      _cache[17] || (_cache[17] = _createTextVNode(" Process "))
                    ]),
                    _: 1
                  }, 8, ["loading", "onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_divider, { class: "mt-5" }),
          _cache[18] || (_cache[18] = _createElementVNode("br", null, null, -1))
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_text, { class: "report-content" }, {
        default: _withCtx(() => [
          (_ctx.showReport)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_v_row, null, {
                  default: _withCtx(() => [
                    (_ctx.git.connectionErrors.length)
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 0,
                          md: "4",
                          sm: "4",
                          cols: "12",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.git.connectionErrorDialogVisible = true))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_alert, {
                              border: "right",
                              "colored-border": "",
                              type: "error",
                              elevation: "2"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Git Connection Errors (" + _toDisplayString(_ctx.git.connectionErrors.length) + ")", 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_v_col, {
                      md: "3",
                      sm: "3",
                      cols: "12"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_alert, {
                          border: "right",
                          "colored-border": "",
                          type: "success",
                          elevation: "2"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Total Hours: " + _toDisplayString(_ctx.removeDecimals(this.grandTotalBillable)), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      md: "5",
                      sm: "5",
                      cols: "12"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_alert, {
                          border: "right",
                          "colored-border": "",
                          type: "success",
                          elevation: "2"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", null, "Total Lines Added (" + _toDisplayString(_ctx.commit.totalAdded) + ")/ Modified (" + _toDisplayString(_ctx.commit.totalModified) + ")/ Deleted (" + _toDisplayString(_ctx.commit.totalDeleted) + ")", 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_divider, { class: "mt-5" }),
                _cache[60] || (_cache[60] = _createElementVNode("br", null, null, -1)),
                (_ctx.timesheet.issues.length)
                  ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timesheet.issues, (teammemberTimesheetIssue) => {
                          return (_openBlock(), _createBlock(_component_v_col, {
                            md: "4",
                            sm: "4",
                            cols: "12",
                            key: `${teammemberTimesheetIssue.teammemberId}`,
                            onClick: ($event: any) => (
              _ctx.showTimesheetIssuesForTeammember(
                teammemberTimesheetIssue.teammemberId,
                teammemberTimesheetIssue.teammemberName,
                teammemberTimesheetIssue.issues
              )
            )
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_alert, {
                                border: "right",
                                "colored-border": "",
                                type: "warning",
                                elevation: "2"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Timesheet issue for " + _toDisplayString(teammemberTimesheetIssue.teammemberName) + " (" + _toDisplayString(teammemberTimesheetIssue.issues.length) + ")", 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        }), 128))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_divider, { class: "mt-5" }),
                _cache[61] || (_cache[61] = _createElementVNode("br", null, null, -1)),
                _createVNode(_component_v_col, {
                  class: "mb-3",
                  md: "12",
                  sm: "12",
                  cols: "12"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          md: "2",
                          sm: "2",
                          cols: "12"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn, {
                              class: "secondary action-button",
                              loading: _ctx.isLoading,
                              onClick: _ctx.sendEmail
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, { class: "mr-2" }, {
                                  default: _withCtx(() => _cache[19] || (_cache[19] = [
                                    _createTextVNode("mdi-send-outline")
                                  ])),
                                  _: 1
                                }),
                                _cache[20] || (_cache[20] = _createTextVNode(" Send "))
                              ]),
                              _: 1
                            }, 8, ["loading", "onClick"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          md: "3",
                          sm: "3",
                          cols: "12"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn, {
                              class: "secondary action-button",
                              loading: _ctx.isLoading,
                              onClick: _ctx.download
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, null, {
                                  default: _withCtx(() => _cache[21] || (_cache[21] = [
                                    _createTextVNode("mdi-download-outline")
                                  ])),
                                  _: 1
                                }),
                                _cache[22] || (_cache[22] = _createTextVNode(" Download Report "))
                              ]),
                              _: 1
                            }, 8, ["loading", "onClick"])
                          ]),
                          _: 1
                        }),
                        (_ctx.isAdmin)
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 0,
                              md: "3",
                              sm: "3",
                              cols: "12"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn, {
                                  class: "accent action-button",
                                  loading: _ctx.isLoading,
                                  onClick: _ctx.syncAllRepositories
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, { "x-small": "" }, {
                                      default: _withCtx(() => _cache[23] || (_cache[23] = [
                                        _createTextVNode("mdi-sync")
                                      ])),
                                      _: 1
                                    }),
                                    _cache[24] || (_cache[24] = _createTextVNode(" Sync Repositories "))
                                  ]),
                                  _: 1
                                }, 8, ["loading", "onClick"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(_component_v_col, {
                          md: "3",
                          sm: "3",
                          cols: "12"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn, {
                              class: "accent action-button",
                              loading: _ctx.isLoading,
                              onClick: _ctx.syncCommitsForSelectedTeamMembers
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, { "x-small": "" }, {
                                  default: _withCtx(() => _cache[25] || (_cache[25] = [
                                    _createTextVNode("mdi-sync")
                                  ])),
                                  _: 1
                                }),
                                _cache[26] || (_cache[26] = _createTextVNode(" Sync Commits "))
                              ]),
                              _: 1
                            }, 8, ["loading", "onClick"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createElementVNode("div", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teammemberReport, (listItem, index) => {
                    return (_openBlock(), _createBlock(_component_v_col, {
                      md: "12",
                      sm: "12",
                      cols: "12",
                      key: 'row_' + index
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listItem.weeklyReport, (weekItems, weekIndex) => {
                          return (_openBlock(), _createBlock(_component_v_row, {
                            class: "mb-10 timesheetreport-body",
                            key: 'week_' + weekIndex
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, {
                                class: "header mb-1 timesheetreport-item",
                                md: "12",
                                sm: "12",
                                cols: "12"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, {
                                        md: "9",
                                        sm: "9",
                                        cols: "9"
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("h3", null, "Timesheet Report Week " + _toDisplayString(weekItems.week), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_v_col, {
                                        md: "3",
                                        sm: "3",
                                        cols: "3",
                                        class: "text-right"
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("h3", null, _toDisplayString(listItem.teammemberName), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_v_col, {
                                md: "12",
                                sm: "12",
                                cols: "12",
                                class: "timesheetreport-item"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, {
                                        xl: "1",
                                        md: "1",
                                        cols: "1",
                                        sm: "1",
                                        class: "text-center titles"
                                      }, {
                                        default: _withCtx(() => _cache[27] || (_cache[27] = [
                                          _createElementVNode("strong", null, "Date", -1)
                                        ])),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        md: "1",
                                        cols: "1",
                                        sm: "1",
                                        class: "text-center titles"
                                      }, {
                                        default: _withCtx(() => _cache[28] || (_cache[28] = [
                                          _createElementVNode("strong", null, "IssueNo", -1)
                                        ])),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        md: "2",
                                        cols: "2",
                                        sm: "2",
                                        class: "text-center titles"
                                      }, {
                                        default: _withCtx(() => _cache[29] || (_cache[29] = [
                                          _createElementVNode("strong", null, "Project", -1)
                                        ])),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        md: "1",
                                        cols: "1",
                                        sm: "1",
                                        class: "text-center titles"
                                      }, {
                                        default: _withCtx(() => _cache[30] || (_cache[30] = [
                                          _createElementVNode("strong", null, "Epic", -1)
                                        ])),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        md: "1",
                                        cols: "1",
                                        sm: "1",
                                        class: "text-center titles"
                                      }, {
                                        default: _withCtx(() => _cache[31] || (_cache[31] = [
                                          _createElementVNode("strong", null, "Activity", -1)
                                        ])),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        xl: "2",
                                        md: "2",
                                        cols: "2",
                                        sm: "2",
                                        class: "text-center titles"
                                      }, {
                                        default: _withCtx(() => _cache[32] || (_cache[32] = [
                                          _createElementVNode("strong", null, "Technology", -1)
                                        ])),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        md: "1",
                                        cols: "1",
                                        sm: "1",
                                        class: "text-center titles"
                                      }, {
                                        default: _withCtx(() => _cache[33] || (_cache[33] = [
                                          _createElementVNode("strong", null, "Effort", -1)
                                        ])),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        md: "2",
                                        cols: "2",
                                        sm: "2",
                                        class: "text-center titles"
                                      }, {
                                        default: _withCtx(() => _cache[34] || (_cache[34] = [
                                          _createElementVNode("strong", null, "Adjustment", -1)
                                        ])),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        md: "1",
                                        cols: "1",
                                        sm: "2",
                                        class: "text-center titles"
                                      }, {
                                        default: _withCtx(() => _cache[35] || (_cache[35] = [
                                          _createElementVNode("strong", null, "Approved", -1)
                                        ])),
                                        _: 1
                                      }),
                                      (!weekItems.timesheets || weekItems.timesheets.length === 0)
                                        ? (_openBlock(), _createBlock(_component_v_col, {
                                            key: 0,
                                            class: "rowItem",
                                            md: "12",
                                            sm: "12",
                                            cols: "12"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_row, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_col, {
                                                    xl: "1",
                                                    md: "1",
                                                    cols: "1",
                                                    sm: "1",
                                                    class: "text-center datas"
                                                  }, {
                                                    default: _withCtx(() => _cache[36] || (_cache[36] = [
                                                      _createTextVNode(" ... ")
                                                    ])),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_v_col, {
                                                    md: "1",
                                                    cols: "1",
                                                    sm: "1",
                                                    class: "text-center datas"
                                                  }, {
                                                    default: _withCtx(() => _cache[37] || (_cache[37] = [
                                                      _createTextVNode(" ... ")
                                                    ])),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_v_col, {
                                                    md: "2",
                                                    cols: "2",
                                                    sm: "2",
                                                    class: "text-center datas"
                                                  }, {
                                                    default: _withCtx(() => _cache[38] || (_cache[38] = [
                                                      _createTextVNode(" ... ")
                                                    ])),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_v_col, {
                                                    md: "1",
                                                    cols: "1",
                                                    sm: "1",
                                                    class: "text-center datas"
                                                  }, {
                                                    default: _withCtx(() => _cache[39] || (_cache[39] = [
                                                      _createTextVNode(" ... ")
                                                    ])),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_v_col, {
                                                    md: "1",
                                                    cols: "1",
                                                    sm: "1",
                                                    class: "text-center datas"
                                                  }, {
                                                    default: _withCtx(() => _cache[40] || (_cache[40] = [
                                                      _createTextVNode(" ... ")
                                                    ])),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_v_col, {
                                                    xl: "2",
                                                    cols: "2",
                                                    sm: "2",
                                                    class: "text-center datas"
                                                  }, {
                                                    default: _withCtx(() => _cache[41] || (_cache[41] = [
                                                      _createTextVNode(" ... ")
                                                    ])),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_v_col, {
                                                    md: "1",
                                                    cols: "1",
                                                    sm: "1",
                                                    class: "text-center datas"
                                                  }, {
                                                    default: _withCtx(() => _cache[42] || (_cache[42] = [
                                                      _createTextVNode(" ... ")
                                                    ])),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_v_col, {
                                                    md: "2",
                                                    cols: "2",
                                                    sm: "2",
                                                    class: "text-center datas"
                                                  }, {
                                                    default: _withCtx(() => _cache[43] || (_cache[43] = [
                                                      _createTextVNode(" ... ")
                                                    ])),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_v_col, {
                                                    md: "1",
                                                    cols: "1",
                                                    sm: "1",
                                                    class: "text-center datas"
                                                  }, {
                                                    default: _withCtx(() => _cache[44] || (_cache[44] = [
                                                      _createTextVNode(" ... ")
                                                    ])),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }))
                                        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(weekItems.timesheets, (timesheetItem, timesheetIndex) => {
                                            return (_openBlock(), _createBlock(_component_v_col, {
                                              style: _normalizeStyle([
                      timesheetIndex % 2 === 0 || timesheetIndex === 0 ? { 'background-color': '#FFDBDB' } : { 'background-color': '#FFCCCC' },
                    ]),
                                              class: "rowItem",
                                              md: "12",
                                              sm: "12",
                                              cols: "12",
                                              key: 'timesheet_' + timesheetIndex
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_row, null, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_col, {
                                                      xl: "1",
                                                      md: "1",
                                                      cols: "1",
                                                      sm: "1",
                                                      class: "text-center datas"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.formatDate(timesheetItem.Date)), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1024),
                                                    _createVNode(_component_v_col, {
                                                      md: "1",
                                                      cols: "1",
                                                      sm: "1",
                                                      class: "text-center datas"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(timesheetItem.IssueNo), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1024),
                                                    _createVNode(_component_v_col, {
                                                      md: "2",
                                                      cols: "2",
                                                      sm: "2",
                                                      class: "text-center datas"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(timesheetItem.Project?.Name), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1024),
                                                    _createVNode(_component_v_col, {
                                                      md: "1",
                                                      cols: "1",
                                                      sm: "1",
                                                      class: "text-center vertical-center datas"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(timesheetItem.Epic), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1024),
                                                    _createVNode(_component_v_col, {
                                                      md: "1",
                                                      cols: "1",
                                                      sm: "1",
                                                      class: "text-center datas"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.getActivityName(timesheetItem.ActivityId)), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1024),
                                                    _createVNode(_component_v_col, {
                                                      xl: "2",
                                                      md: "2",
                                                      cols: "2",
                                                      sm: "2",
                                                      class: "text-center datas"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.getTechnologyName(timesheetItem.TechnologyId)), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1024),
                                                    _createVNode(_component_v_col, {
                                                      md: "1",
                                                      cols: "1",
                                                      sm: "1",
                                                      class: "text-center datas"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(timesheetItem.Effort), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1024),
                                                    _createVNode(_component_v_col, {
                                                      cols: "2",
                                                      sm: "2",
                                                      md: "2",
                                                      class: "text-center datas"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(timesheetItem.Project?.Name ? timesheetItem.Adjustment : ""), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1024),
                                                    _createVNode(_component_v_col, {
                                                      cols: "1",
                                                      sm: "1",
                                                      md: "1",
                                                      class: "text-center datas"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        (timesheetItem.Project?.Name)
                                                          ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                                                              (timesheetItem.isLocked)
                                                                ? (_openBlock(), _createBlock(_component_v_icon, {
                                                                    key: 0,
                                                                    color: "success"
                                                                  }, {
                                                                    default: _withCtx(() => _cache[45] || (_cache[45] = [
                                                                      _createTextVNode("mdi-lock")
                                                                    ])),
                                                                    _: 1
                                                                  }))
                                                                : (_openBlock(), _createBlock(_component_v_icon, {
                                                                    key: 1,
                                                                    color: "error"
                                                                  }, {
                                                                    default: _withCtx(() => _cache[46] || (_cache[46] = [
                                                                      _createTextVNode("mdi-lock-open")
                                                                    ])),
                                                                    _: 1
                                                                  }))
                                                            ]))
                                                          : _createCommentVNode("", true)
                                                      ]),
                                                      _: 2
                                                    }, 1024),
                                                    _createVNode(_component_v_col, {
                                                      sm: "2",
                                                      cols: "2",
                                                      md: "2",
                                                      class: "text-center datas"
                                                    }, {
                                                      default: _withCtx(() => _cache[47] || (_cache[47] = [
                                                        _createTextVNode(" Description ")
                                                      ])),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_v_col, {
                                                      sm: "10",
                                                      cols: "10",
                                                      md: "10",
                                                      class: "datas"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(timesheetItem.Description), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1024),
                                                    (timesheetItem.Commits != null && timesheetItem.Commits.length > 0)
                                                      ? (_openBlock(), _createBlock(_component_v_col, { key: 0 }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_col, {
                                                              md: "2",
                                                              class: "text-center datas"
                                                            }, {
                                                              default: _withCtx(() => _cache[48] || (_cache[48] = [
                                                                _createTextVNode(" Commits ")
                                                              ])),
                                                              _: 1
                                                            }),
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(timesheetItem.Commits, (commit) => {
                                                              return (_openBlock(), _createBlock(_component_v_col, {
                                                                md: "12",
                                                                class: "datas",
                                                                key: commit.id
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _cache[50] || (_cache[50] = _createTextVNode(" Lines Added= ")),
                                                                  _createElementVNode("strong", null, _toDisplayString(commit.linesAdded), 1),
                                                                  _cache[51] || (_cache[51] = _createTextVNode("| Lines Modified= ")),
                                                                  _createElementVNode("strong", null, _toDisplayString(commit.linesChanged), 1),
                                                                  _cache[52] || (_cache[52] = _createTextVNode(" | Lines Deleted= ")),
                                                                  _createElementVNode("strong", null, _toDisplayString(commit.linesDeleted), 1),
                                                                  _cache[53] || (_cache[53] = _createTextVNode(" | Description= ")),
                                                                  _createElementVNode("strong", null, _toDisplayString(commit.messageShort), 1),
                                                                  (commit.date)
                                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                                                                        _cache[49] || (_cache[49] = _createTextVNode("| Date= ")),
                                                                        _createElementVNode("strong", null, _toDisplayString(_ctx.formatDate(commit.date)), 1)
                                                                      ]))
                                                                    : _createCommentVNode("", true)
                                                                ]),
                                                                _: 2
                                                              }, 1024))
                                                            }), 128))
                                                          ]),
                                                          _: 2
                                                        }, 1024))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1032, ["style"]))
                                          }), 128)),
                                      _createVNode(_component_v_col, {
                                        class: "weeklyTotal pl-10",
                                        md: "12",
                                        sm: "12"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_row, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_col, {
                                                md: "3",
                                                sm: "4",
                                                cols: "4"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("strong", null, " WEEK TOTAL HOURS: " + _toDisplayString(_ctx.removeDecimals(_ctx.calculateHours(weekItems.timesheets))), 1)
                                                ]),
                                                _: 2
                                              }, 1024),
                                              _createVNode(_component_v_col, {
                                                md: "3",
                                                sm: "4",
                                                cols: "4"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("strong", null, " WEEK TOTAL ADJUSTMENT: " + _toDisplayString(_ctx.removeDecimals(_ctx.calculateAdjustment(weekItems.timesheets))), 1)
                                                ]),
                                                _: 2
                                              }, 1024),
                                              _createVNode(_component_v_col, {
                                                md: "3",
                                                sm: "4",
                                                cols: "4"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("strong", null, " WEEK TOTAL BILLABLE: " + _toDisplayString(_ctx.removeDecimals(_ctx.calculateBillable(weekItems.timesheets))), 1)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128)),
                        _createVNode(_component_v_row, { class: "mt-5 mb-5" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              class: "mt-2 weeklyTotal",
                              md: "12",
                              sm: "12",
                              cols: "12"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      md: "4",
                                      sm: "4",
                                      cols: "12",
                                      class: "text-center"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("strong", null, [
                                          _cache[54] || (_cache[54] = _createTextVNode(" TEAMMEMBER TOTAL HOURS: ")),
                                          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.removeDecimals(_ctx.calculateTotalHours(listItem.weeklyReport))), 1)
                                        ])
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_v_col, {
                                      md: "4",
                                      sm: "4",
                                      cols: "12",
                                      class: "text-center"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("strong", null, [
                                          _cache[55] || (_cache[55] = _createTextVNode(" TEAMMEMBER TOTAL ADJUSTMENT: ")),
                                          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.removeDecimals(_ctx.calculateTotalAdjustment(listItem.weeklyReport))), 1)
                                        ])
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_v_col, {
                                      md: "4",
                                      sm: "4",
                                      cols: "12",
                                      class: "text-center"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("strong", null, [
                                          _cache[56] || (_cache[56] = _createTextVNode(" TEAMMEMBER TOTAL BILLABLE: ")),
                                          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.removeDecimals(_ctx.calculateTotalBillable(listItem.weeklyReport))), 1)
                                        ])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                (_ctx.teammemberReport && _ctx.teammemberReport.length != 0)
                  ? (_openBlock(), _createBlock(_component_v_col, {
                      key: 1,
                      md: "12",
                      sm: "12",
                      cols: "12"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              class: "mt-2 weeklyTotal",
                              md: "12",
                              sm: "12",
                              cols: "12"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      md: "4",
                                      sm: "4",
                                      cols: "12",
                                      class: "text-center"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("strong", null, [
                                          _cache[57] || (_cache[57] = _createTextVNode(" GRAND TOTAL HOURS: ")),
                                          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.removeDecimals(_ctx.grandTotalHour)), 1)
                                        ])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      md: "4",
                                      sm: "4",
                                      cols: "12",
                                      class: "text-center"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("strong", null, [
                                          _cache[58] || (_cache[58] = _createTextVNode(" GRAND TOTAL ADJUSTMENT: ")),
                                          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.removeDecimals(_ctx.grandTotalAdjustment)), 1)
                                        ])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      md: "4",
                                      sm: "4",
                                      cols: "12",
                                      class: "text-center"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("strong", null, [
                                          _cache[59] || (_cache[59] = _createTextVNode(" GRAND TOTAL BILLABLE: ")),
                                          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.removeDecimals(_ctx.grandTotalBillable)), 1)
                                        ])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_v_dialog, {
        modelValue: _ctx.git.connectionErrorDialogVisible,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.git.connectionErrorDialogVisible) = $event)),
        onKeydown: _cache[6] || (_cache[6] = _withKeys(($event: any) => (_ctx.git.connectionErrorDialogVisible = false), ["esc"])),
        persistent: "",
        "max-width": "860"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, null, {
                default: _withCtx(() => _cache[62] || (_cache[62] = [
                  _createTextVNode("Connection Errors")
                ])),
                _: 1
              }),
              _cache[67] || (_cache[67] = _createElementVNode("hr", null, null, -1)),
              _createVNode(_component_v_card_text, { class: "pt-3 message-text" }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.git.connectionErrors, (item, index) => {
                    return (_openBlock(), _createElementBlock("p", {
                      key: `git-err-${index}`,
                      border: "right",
                      "colored-border": "",
                      type: "error",
                      elevation: "2"
                    }, [
                      _createElementVNode("span", null, [
                        _cache[63] || (_cache[63] = _createTextVNode(" -")),
                        _createElementVNode("b", null, _toDisplayString(item.repositoryHttpsLink) + ": ", 1)
                      ]),
                      _createTextVNode(" " + _toDisplayString(item.errorMessage), 1)
                    ]))
                  }), 128)),
                  _cache[64] || (_cache[64] = _createElementVNode("br", null, null, -1))
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_actions, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { md: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        class: "secondary",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.git.connectionErrorDialogVisible = false))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => _cache[65] || (_cache[65] = [
                              _createTextVNode("mdi-close")
                            ])),
                            _: 1
                          }),
                          _cache[66] || (_cache[66] = _createTextVNode(" Close "))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_dialog, {
        modelValue: _ctx.resultLogVisible,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.resultLogVisible) = $event)),
        onKeydown: _cache[9] || (_cache[9] = _withKeys(($event: any) => (_ctx.resultLogVisible = false), ["esc"])),
        persistent: "",
        "max-width": "860"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, null, {
                default: _withCtx(() => _cache[68] || (_cache[68] = [
                  _createTextVNode("Log Result")
                ])),
                _: 1
              }),
              _cache[71] || (_cache[71] = _createElementVNode("hr", null, null, -1)),
              _createVNode(_component_v_card_text, { class: "pt-3 message-text" }, {
                default: _withCtx(() => [
                  _createElementVNode("p", { innerHTML: _ctx.resultlogContent }, null, 8, _hoisted_10)
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_actions, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { md: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        class: "secondary",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.resultLogVisible = false))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => _cache[69] || (_cache[69] = [
                              _createTextVNode("mdi-close")
                            ])),
                            _: 1
                          }),
                          _cache[70] || (_cache[70] = _createTextVNode(" Close "))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_dialog, {
        modelValue: _ctx.timesheet.timesheetsIssuesDialogVisible,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.timesheet.timesheetsIssuesDialogVisible) = $event)),
        onKeydown: _cache[12] || (_cache[12] = _withKeys(($event: any) => (_ctx.timesheet.timesheetsIssuesDialogVisible = false), ["esc"])),
        persistent: "",
        "max-width": "860"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, null, {
                default: _withCtx(() => [
                  _createTextVNode("Timesheet Issues For " + _toDisplayString(_ctx.timesheet.selectedTeammemberName), 1)
                ]),
                _: 1
              }),
              _cache[74] || (_cache[74] = _createElementVNode("hr", null, null, -1)),
              _createVNode(_component_v_card_text, { class: "pt-3 message-text" }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timesheet.selectedIssuesForTeammember, (item, index) => {
                    return (_openBlock(), _createElementBlock("p", {
                      key: `git-err-${index}`,
                      border: "right",
                      "colored-border": "",
                      type: "warning",
                      elevation: "2",
                      innerHTML: item
                    }, null, 8, _hoisted_11))
                  }), 128))
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_actions, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { md: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        class: "secondary",
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.timesheet.timesheetsIssuesDialogVisible = false))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => _cache[72] || (_cache[72] = [
                              _createTextVNode("mdi-close")
                            ])),
                            _: 1
                          }),
                          _cache[73] || (_cache[73] = _createTextVNode(" Close "))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}